// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b431aa50","239":"d93f81dc","453":"0304fc70","455":"e243e590"}[chunkId] + ".chunk.js";
};